module.exports = __webpack_public_path__ + "img/project.faa6c575.png";